import { ClientAppLogout } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { CultureLocaleService } from './services/culture-locale.service';

export function AppIntializer(cultureLocaleService: CultureLocaleService) {
    ClientAppLogout();
    return () => cultureLocaleService.initialise();
}